import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@df/core/app';
@Component({
    selector: 'go-back',
    templateUrl: 'go-back-button.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class GoBackButtonComponent {
    constructor(
        private app: App,
        private router: Router
    ) {}
    goBack(): void {
        this.app.meta.previousState ? window.history.back() : this.router.navigateByUrl('/');
    }
}
